import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../../../components/ui/dialog';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { Checkbox } from '../../../components/ui/checkbox';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table';
import { Users, ArrowUpDown } from 'lucide-react';

export const ManageRosterDialog = ({
  open, onOpenChange, selectedTeam, availablePlayers, selectedPlayerIds,
  onTogglePlayer, onSave, sortState, onToggleSort, sortPlayers
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto" aria-describedby="manage-players-description">
      <DialogHeader>
        <DialogTitle>Manage Roster - {selectedTeam?.name}</DialogTitle>
        <DialogDescription id="manage-players-description">Select players to add to this team. Players can be on multiple teams.</DialogDescription>
      </DialogHeader>
      <div className="py-4">
        {availablePlayers.length === 0 ? (
          <div className="text-center py-8 text-slate-500">
            <Users className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p>No available players found for this age category.</p>
            <p className="text-sm mt-2">Players need to be registered for the tournament first.</p>
          </div>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="w-12">Select</TableHead>
                <TableHead>
                  <button onClick={() => onToggleSort('player_name')} className="flex items-center gap-1 hover:text-slate-900 font-medium">
                    Player<ArrowUpDown className={`h-3 w-3 ${sortState.field === 'player_name' ? 'text-blue-600' : ''}`} />
                  </button>
                </TableHead>
                <TableHead>
                  <button onClick={() => onToggleSort('parent_name')} className="flex items-center gap-1 hover:text-slate-900 font-medium">
                    Parent<ArrowUpDown className={`h-3 w-3 ${sortState.field === 'parent_name' ? 'text-blue-600' : ''}`} />
                  </button>
                </TableHead>
                <TableHead>
                  <button onClick={() => onToggleSort('payment_status')} className="flex items-center gap-1 hover:text-slate-900 font-medium">
                    Payment<ArrowUpDown className={`h-3 w-3 ${sortState.field === 'payment_status' ? 'text-blue-600' : ''}`} />
                  </button>
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {sortPlayers(availablePlayers).map(player => (
                <TableRow key={player.player_id || player.id}>
                  <TableCell>
                    <Checkbox checked={selectedPlayerIds.includes(player.player_id || player.id)} onCheckedChange={() => onTogglePlayer(player.player_id || player.id)} data-testid={`select-roster-player-${player.player_id || player.id}`} />
                  </TableCell>
                  <TableCell><p className="font-medium">{player.player_name || player.full_name}</p></TableCell>
                  <TableCell><div><p>{player.parent_name}</p><p className="text-xs text-slate-500">{player.parent_email}</p></div></TableCell>
                  <TableCell>
                    <Badge className={player.payment_status === 'paid' ? 'bg-green-100 text-green-700' : player.payment_status === 'pending' ? 'bg-yellow-100 text-yellow-700' : 'bg-red-100 text-red-700'}>
                      {player.payment_status || 'unpaid'}
                    </Badge>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
      <DialogFooter>
        <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
        <Button onClick={onSave} data-testid="save-team-roster-btn">Save Roster ({selectedPlayerIds.length} players)</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
